import { render, staticRenderFns } from "./AscDocMgmtContainer.vue?vue&type=template&id=34722779&"
import script from "./AscDocMgmtContainer.vue?vue&type=script&lang=js&"
export * from "./AscDocMgmtContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports